import React from 'react'
import "./about.css"
import Support from '../../componets/Support';
import aboutImg from "../../images/aboutfounder.jpeg"
import aboutImg1 from "../../images/about1.jpg"
import aboutImg2 from "../../images/aboutImage2.jpg"

const About = () => {
  return (
    <section className="about-section">
      <h2 className="about-head">About Us</h2>
      <h3 className="about-title">Welcome to aremudami_luxury Real Estate</h3>
      
      <div className="about-content">
          <div className="about-details-container">
            <div className="about-details">
              <span className="about-text">
                Welcome to aremudami_luxury real estate agency! Our dedicated team offers top-notch services for all your real estate needs. From buying to selling or renting, we provide expert guidance and personalized solutions. Trust, integrity, and transparency are the foundation of our lasting relationships with valued clients like you. Whether you're a first-time homebuyer or an investor, we're here to support you every step of the way. Experience the difference with us!
              </span>
              
              <div className="about-img-container">
                <img src={aboutImg1} className="about-img" alt="Office" loading="lazy" />
              </div>
            </div>
          </div>

          <div className="about-details-container">
            <h3 className="about-title">Our Mission</h3>

            <div className="about-details">
            <div className="about-img-container">
                <img src={aboutImg} className="about-img" alt="Office"  loading="lazy" />
              </div>

              <span className="about-text">
                Our mission is to connect buyers and sellers, making the real estate process seamless and enjoyable for all parties involved.Our dedication is to provide a trusted and reliable environment where buyers and sellers can confidently engage in property transactions, ensuring satisfaction and success for all."
              </span>
            </div>
          </div>

          <div className="about-details-container">
            <h3 className="about-title">Why Choose aremudami-luxury Real Estate?</h3>

            <div className="about-details">
              <ul>
                <li> &bull; Extensive market knowledge</li>
                <li> &bull; Wide selection of properties</li>
                <li> &bull; Experienced and dedicated realtors</li>
                <li> &bull; Personalized service tailored to your needs</li>
                <li> &bull; Transparent and honest communication</li>
                <li> &bull; Efficient and smooth buying/selling process</li>
              </ul>

              <div className="about-img-container">
                <img src={aboutImg2} className="about-img" alt="Office"  loading="lazy" />
              </div>
            </div>
          </div>

        <div>

        <div>
          <div></div>
          <div>
            <img src="" alt="" />
          </div>
          
        </div>
    </div>

         <Support />
      </div>
    </section>
  );
}

export default About